import React from 'react';
import { Label, Checked, Option, Text, Input } from './styles';

export const Checkbox = ({
  name,
  selected,
  disabled,
  label,
  value,
  hasError,
  className,
  onSelect,
}: CheckboxProps) => {
  const fullClassName = className ? `${className} checkbox` : 'checkbox';
  return (
    <Label
      htmlFor={name}
      selected={selected}
      disabled={disabled}
      className={fullClassName}
      hasError={hasError}
    >
      <Option selected={selected} disabled={disabled}>
        <Checked selected={selected} disabled={disabled} />
      </Option>
      {label ? <Text>{label}</Text> : null}
      <Input
        type="checkbox"
        disabled={disabled}
        checked={selected}
        id={name}
        value={value}
        onChange={() => onSelect(value, !selected)}
      />
    </Label>
  );
};

export interface CheckboxProps {
  name: string;
  disabled?: boolean;
  selected?: boolean;
  label?: string;
  value: string;
  className?: string;
  hasError?: boolean;
  onSelect: (name: string, state: boolean) => void;
}
